<div>
  <label class="form-label">{{ 'Matrikel' | tekstresource }}</label>
  <bom-autocomplete
    [placeholder]="'SkrivMatrikel' | tekstresource"
    [itemsService]="matrikelsoegningService"
    (valueSelected)="onValueSelected($event)"
    (valueActivated)="onValueActivated()"
  >
  </bom-autocomplete>
</div>
